module.exports = __webpack_public_path__ + "img/rerun_icon.56d904c0.svg";